var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    fill: "#9DA1AE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 8,
    height: 2,
    fill: "#9DA1AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 8,
    height: 2,
    fill: "#9DA1AE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 13,
    height: 2,
    fill: "#0B1435"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 5.00099L14.6421 7.63925L12.0002 5.50169",
    stroke: "#FF2C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C13.5 1 14 4 14.5 7",
    stroke: "#FF2C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.f1087ef7354d7a792b2b4190d61b5eca.svg";
export { ForwardRef as ReactComponent };